import React from "react";
import { Loader2, AlertCircle, CheckCircle2 } from "lucide-react";
import { getToolCallFriendlyName } from "./toolCallFriendlyNames";

export function ToolCallCard({
  name,
  input,
  result,
  state,
}: {
  name: string;
  input?: unknown;
  result: unknown;
  state: string;
}) {
  const isToolLoading = state === "input-streaming" || state === "input-available";
  const isError =
    result && typeof result === "object" && !!(result as Record<string, unknown>).error;

  return (
    <div className="my-1.5 rounded-2xl bg-surface-low overflow-hidden text-sm">
      <div className="w-full flex items-center gap-2 px-3 py-2 text-xs">
        {isToolLoading ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin text-primary" />
        ) : isError ? (
          <AlertCircle className="w-3.5 h-3.5 text-red-500" />
        ) : (
          <CheckCircle2 className="w-3.5 h-3.5 text-emerald-500" />
        )}
        <span className="font-medium text-foreground/80">{getToolCallFriendlyName(name, input)}</span>
      </div>
    </div>
  );
}
